import "./About.scss";
import { useTranslation } from "react-i18next";

const About = ()=> {
  const { t } = useTranslation();
  const aboutmeData = t("aboutmeData.content");
  const stringParts = aboutmeData.split("\n");
    

    // Join the parts with <br /> elements
    const stringWithBreaks = stringParts.join("<br /><br />");
    return (
      <section id="about" className="about">
        <h2 className="about__title">
          <span className="about__title--special">
            {t("aboutmeData.title1")}
          </span>{" "}
          {t("aboutmeData.title2")}
        </h2>
        <div className="about__container">
          <div className="about__image"></div>
          <div className="about__content">
            <div
              className="about__longString"
              dangerouslySetInnerHTML={{ __html: stringWithBreaks }}
            />
          </div>
        </div>
      </section>
    );
}

export default About;